export class SiteSearchValidation
{
	static SiteSearch(searchString: string): boolean
	{
		let critiera = searchString;
		var errors = "";

		critiera = critiera.replace("<", "&lt;").replace(">", "&gt;").replace("'", "&rsquo;").replace("\"\"", "&#x22;").replace(")", "&#x29;").replace("(", "&#x28;").replace("src=", "");

		if (critiera !== null && critiera !== undefined && critiera !== "")
		{
			return true;
		}
		else
		{
			return false;
		}
	}
}